import useHttpClient from 'hooks/useHttpsClient'
import Toast from 'components/toast/Toast';

const useDashboardService = () => {
    const { sendRequest } = useHttpClient();
    const showErrorMessage = (message) => {
        Toast.error(message)
      };
    const getActivity = async () => {
        try {
            const response = await sendRequest('/analytics/activity', 'get')
            if (response.status == 200) {
                return response.data
            }

        } catch (err) {
            showErrorMessage("Problem receiving activity data")
        }
    }

    const getIndicators = async () => {
        try {
            const response = await sendRequest('/analytics/indicators', 'get')
            if (response.status == 200) {
                return response.data
            }
        } catch (err) {
            showErrorMessage("Problem receiving indicators data")
        }
    }

  
    return {
        getActivity,
        getIndicators,
    }
}

export default useDashboardService